module.exports = __webpack_public_path__ + "img/service-and-shop-filter-ford.0ee57fb5.jpg";